import React from 'react'
import { useTheme } from '@material-ui/core/styles'
import { NVLVendor } from '.'
import { VendorListRow } from './VendorListRow'
import { UpdatedPricingRequest } from '../../../store'
import { Container } from '../../../components'
import { Pagination } from '@material-ui/lab'

const PAGINATION_HEIGHT = 80

interface Props {
    vendors: NVLVendor[]
    count: number
    page: number
    pageSize: number
    onPageChange: (page: number) => void
    setSelectedVendor: (vendor: NVLVendor) => void
    requestUpdatedPricing: (req: UpdatedPricingRequest) => Promise<void>
    selectedVendor?: NVLVendor
    emptyMessage?: string
}
const VendorList = (props: Props) => {
    const {
        vendors,
        count,
        page,
        pageSize,
        onPageChange,
        setSelectedVendor,
        selectedVendor,
        requestUpdatedPricing,
        emptyMessage = 'No vendors to show in this list.',
    } = props

    const theme = useTheme()
    const pageCount = Math.max(1, Math.ceil(count / pageSize))

    if (count === 0) {
        return (
            <Container
                style={{
                    flex: 1,
                    minHeight: 0,
                    height: '100%',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: theme.spacing(4),
                    textAlign: 'center',
                    color: theme.palette.grey[600],
                }}
            >
                <Container
                    style={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: theme.palette.grey[800],
                        marginBottom: theme.spacing(1),
                    }}
                >
                    No vendors found
                </Container>
                <Container style={{ fontSize: 14, maxWidth: 360 }}>
                    {emptyMessage}
                </Container>
            </Container>
        )
    }

    return (
        <Container
            style={{
                flex: 1,
                minHeight: 0,
                height: '100%',
                flexDirection: 'column',
                overflow: 'hidden',
            }}
        >
            <Container
                style={{
                    flex: 1,
                    minHeight: 0,
                    overflow: 'auto',
                    paddingRight: theme.spacing(2),
                    flexDirection: 'column',
                }}
            >
                {vendors.length === 0 ? (
                    <Container
                        style={{
                            flex: 1,
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: theme.spacing(4),
                            textAlign: 'center',
                            color: theme.palette.grey[600],
                            fontSize: 14,
                        }}
                    >
                        {emptyMessage}
                    </Container>
                ) : (
                    vendors.map((nvlVendor) => {
                        return (
                            <VendorListRow
                                vendor={nvlVendor}
                                key={`NVL_VENDOR_ROW_${nvlVendor.id}`}
                                setSelectedVendor={setSelectedVendor}
                                isSelected={nvlVendor.id === selectedVendor?.id}
                                requestUpdatedPricing={requestUpdatedPricing}
                            />
                        )
                    })
                )}
            </Container>

            <Container
                alignItems="center"
                style={{
                    height: PAGINATION_HEIGHT,
                    minHeight: PAGINATION_HEIGHT,
                    maxHeight: PAGINATION_HEIGHT,
                    flexShrink: 0,
                    gap: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                }}
            >
                <span
                    style={{
                        color: theme.palette.grey[600],
                        fontWeight: 400,
                        fontSize: 13,
                        whiteSpace: 'nowrap',
                    }}
                >
                    {count} {count === 1 ? 'vendor' : 'vendors'}
                </span>
                <Pagination
                    count={pageCount}
                    page={page}
                    onChange={(_: unknown, newPage: number) => {
                        onPageChange(newPage)
                    }}
                    variant="outlined"
                    shape="rounded"
                    size="small"
                />
            </Container>
        </Container>
    )
}

export default VendorList
